import React from "react";
import "./App.css";

import Routes from "./Routes";

import { useSelector } from "react-redux";
import WaitingLoader from "./ReusableComponents/Loader";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider, App as AntApp } from "antd";
import themeConfig from "./theme/themeConfig";

const queryClient = new QueryClient();

function App() {
  const loading = useSelector((state) => state.loading);

  return (
    <ConfigProvider theme={themeConfig}>
      <AntApp>
        <QueryClientProvider client={queryClient}>
          {loading.Loading && <WaitingLoader />}
          <Routes />
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
